export class ModelManagement {
    _id: string;
    id: string;
    name:string;
    alert_notes:string;
    currency:string;
    skills: string;
    channel: string;
    source: string;
    technology: string;
    farming_by: string;
    hunting_by: string;
    priority: {name:string, displayname:string};
    status: {name:string, displayname:string};
    workon: {name:string, displayname:string};
    projectbudget: string;
    IP: string;
    description:string;
    references: string;
    notes:string;
    admin_notes:string;
    Communication: string;
    sprints: string;
    mom: string;
    dmsfrs: string;
    kpi: string;
    reports: string;
    workdairy: string;
    bitbucket: string;
    demo: string;
    qa: string;
    crequest: string;
    isalert: string;
    lead_id:string;
    rate: string;
    engage_tags: string;
    feature: string;
    owner: {name:string, displayname:string};
    auditor: {name:string, displayname:string};
    publisher: {name:string, displayname:string};
    marketer: {name:string, displayname:string};
    codeName:string;
    config_notes:string;
    demo_notes :string;
    domain:string;
    developmentStage: {name:string, displayname:string};
    marketStage:{name:string, displayname:string};
    configState:{name:string, displayname:string};
    modelCategory:{name:string, displayname:string};
    modelVariant :{name:string, displayname:string};
    modelSource:{name:string, displayname:string};
    project_tag: {name:string, displayname:string};
}

    
